import './settings-row.scss';

type SettingsRowProps = {
	title: string;
	children: React.ReactNode;
};

export const SettingsRow: React.FC<SettingsRowProps> = ({ title, children }) => {
	return (
		<div className='setting-row'>
			<div className='settings-row-title'>{title}</div>
			<div className='settings-input'>{children}</div>
		</div>
	);
};
